import $ from 'wee-dom';
import $events from 'wee-events';
import { $each } from 'core/dom';
import $screen from 'wee-screen';
import { RouteHandler } from 'wee-routes';
import { closeSearch } from '../search/index.js';

const $body = $('.body');
const $main = $('.main');
const $toggle = $('.nav-toggle__center');
const $headerCont = $('.header__container');
const navTop = $('.header__container').offset().top;
const $toggleContainer = $('.nav-toggle');
const $desktopNav = $('.navigation__list.-desktop');
const $navigation = $('.navigation');
const $search = $('.search');
const $topLevelNav = $('.-top-level');
const $logo = $('.header__logo-link');

function openMobileNav() {
	$toggle.addClass('-active');
	$body.addClass('-show-menu');
	$topLevelNav.changeTabindex();
	$logo.attr('tabindex', '-1');
}

function closeMobileNav() {
	$toggle.removeClass('-active');
	$body.removeClass('-show-menu');
	$topLevelNav.changeTabindex();
	$logo.attr('tabindex', '1');
}

function fixNav(el) {
	const $el = $(el);
	let	scrolled = false;
	let	scrollTop = $el.scrollTop();

	if (scrollTop >= navTop && ! scrolled) {
		$body.addClass('-fixed-header');
		$main.css('paddingTop', `${$headerCont.height()}px`);
		scrolled = true;
	} else if (scrollTop < navTop) {
		$body.removeClass('-fixed-header');
		$main.css('paddingTop', 0);
		scrolled = false;
	}
}

export default new RouteHandler({
	init() {
		$screen.map([
			{
				min: 1,
				callback() {
					$events.on({
						'window':  {
							scroll: (e, el) => {
								fixNav(el);
							}
						},
					});
				}
			},
			{
				max: 3,
				callback() {
					$('.header__content').prepend($toggleContainer);
					$('.site-wrapper').before($navigation);
					$('.menu-instructions').hide();
					$toggleContainer.attr('tabindex', '1');
					$logo.attr('tabindex', '0');

					$events.on({
						'.nav-toggle': {
							click: () => {
								$toggle.hasClass('-active') ? closeMobileNav() : openMobileNav();
							},
							keydown: (e, el) => {
								if (e.keyCode === 13) {
									$toggle.hasClass('-active') ? closeMobileNav() : openMobileNav();
								}
							}
						},
						'.body':  {
							click: (e, el) => {
								if (e.target !== $('.nav-toggle')[0] &&
									(! $(e.target).eq(0).hasClass('navigation__item')) &&
									(! $(e.target).eq(0).hasClass('navigation__link')) &&
									(! $(e.target).eq(0).hasClass('navigation__subitem')) &&
									(! $(e.target).eq(0).hasClass('navigation__sublink'))
								) {
									if ($(el).hasClass('-show-menu')) {
										closeMobileNav();
									}
								}
							}
						},
						'.js-top-level': {
							click: (e, el) => {
								const $el = $(el);

								$topLevelNav.each().addClass('-closed')
									.removeClass('-open')
									.attr('aria-expanded', 'false');

								$el.removeClass('-closed')
									.addClass('-open')
									.attr('aria-expanded', 'true');
							},
							keyup: (e, el) => {
								const $el = $(el);

								if (e.keyCode === 13 && (! $(e.target).hasClass('-has-menu'))) {
									$topLevelNav.each().addClass('-closed')
										.removeClass('-open')
										.attr('aria-expanded', 'false');

									$el.removeClass('-closed')
										.addClass('-open')
										.attr('aria-expanded', 'true')
										.find($('.-has-menu')).changeTabindex();
								}
							}
						},
						'.js-has-menu': {
							click: (e, el) => {
								$(el).toggleClass('-closed').toggleClass('-open');
							},
							keydown: (e, el) => {
								const $el = $(el);

								if (e.keyCode === 13) {
									if ($el.hasClass('-closed')) {
										$el.siblings($('.-has-menu')).addClass('-closed')
											.removeClass('-open')
											.attr('aria-expanded', 'false');

										$el.removeClass('-closed')
											.addClass('-open')
											.attr('aria-expanded', 'true');
									} else {
										$el.removeClass('-open')
											.addClass('-closed')
											.attr('aria-expanded', 'false');
									}
								}
							}
						}
					});
				}
			},
			{
				min: 4,
				callback() {
					$('.header__content').append($('.search-icon'));
					
					$('.menu-instructions').show();
					$logo.attr('tabindex', '1');

					$events.on({
						'.js-top-level': {
							click: (e, el) => {
								if ($('.search-container').hasClass('-active')) {
									let $el = $(el);
									let $sublist = $el.children('.sublist-wrapper');

									$el.addClass('-active');
									$sublist.css('left', `-${$el.offset().left}px`).addClass('-active');
								}
							},
							mouseenter: (e, el) => {
								if (! $('.search-container').hasClass('-active')) {
									let $el = $(el);
									let $sublist = $el.children('.sublist-wrapper');

									$el.addClass('-active');
									$sublist.css('left', `-${$el.offset().left}px`).addClass('-active');
								}
							},
							mouseleave: (e, el) => {
								let $el = $(el);
								let $sublist = $el.children('.sublist-wrapper');

								$el.removeClass('-active');
								$sublist.removeClass('-active');
							},
							keyup: (e, el) => {
								let $el = $(el);
								let $sublist = $el.children('.sublist-wrapper');

								if (e.keyCode === 13) {
									$('.js-top-level').removeClass('-active');
									$el.addClass('-active');
									$('.sublist-wrapper').removeClass('-active');
									$sublist.css('left', `-${$el.offset().left}px`)
										.addClass('-active');
									closeSearch();
								} else if (e.keyCode === 27 && $sublist.hasClass('-active')) {
									$el.removeClass('-active');
									$sublist.removeClass('-active');
									$('.menu-close-instructions').hide();
									$el[0].focus();
								}
							}
						},
					});
				}
			}
		]);
	}
});